/**
 * Maestros — shell con tabs lineales como rutas hermanas.
 *
 * Sub-rutas: /maestros/productos, /maestros/clientes, /maestros/eventos.
 * Usuarios se movió a /seguridad/usuarios (paquete L).
 */

import { NavLink, Outlet } from 'react-router-dom';
import { Package, Users, ListChecks } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/maestros/productos', label: 'Productos', icon: Package },
  { to: '/maestros/clientes', label: 'Clientes', icon: Users },
  { to: '/maestros/eventos', label: 'Eventos ANMAT', icon: ListChecks },
] as const;

export function MaestrosShell() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-everex-azul">Maestros</CardTitle>
          <p className="text-xs text-gray-600">
            Catálogos read-only del sistema. La gestión completa (CRUD con audit) es deuda
            regulatoria para producción — ver Handoff técnico.
          </p>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-2 border-b border-gray-200">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  cn(
                    'px-4 py-2 text-sm transition',
                    isActive
                      ? 'border-b-2 border-everex-naranja font-semibold text-everex-azul'
                      : 'text-gray-600 hover:text-everex-azul',
                  )
                }
              >
                <t.icon className="mr-1 inline h-4 w-4" />
                {t.label}
              </NavLink>
            ))}
          </div>
        </CardContent>
      </Card>

      <Outlet />
    </div>
  );
}
